const action = {
    general: 'Si è verificato un errore durante l’esecuzione dell’azione. Riprova più tardi.',
    sign_in_identifier_changed: 'L’azione non può modificare l’identificatore di accesso usato per questa verifica.',
};
export default Object.freeze(action);
